module.exports = __webpack_public_path__ + "static/media/UKCEH-Logo.384e8e31.png";